import type { RouteRecordRaw } from 'vue-router'

export const adminRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        path: '',
        redirect: 'overview',
      },
      {
        component: async () => import('../views/BrandListView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'admin.brands',
        },
        name: 'brands',
        path: 'overview',
      },
      {
        component: async () => import('../views/LocationListView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'admin.locations',
        },
        name: 'locations',
        path: 'locations',
      },
      {
        component: async () => import('../views/UserView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'admin.users',
        },
        name: 'users',
        path: 'users',
      },
      {
        component: async () => import('../views/GBPOAuthView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'admin.gbp-oauth',
        },
        name: 'admin.gbp-oauth',
        path: 'gbp-oauth',
      },
    ],
    component: async () => import('../views/AdminView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
    },
    path: 'admin',
  },
]
